import type { SVGProps } from 'react';

export const PausedNotification = (props: SVGProps<any>) => (
  <svg
    height="20px"
    version="1.1"
    viewBox="0 0 20 20"
    width="20px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g transform="translate(-877, -270)">
        <g transform="translate(877, 270)">
          <rect height="20" width="20" x="0" y="0"></rect>
          <g transform="translate(3.2172, 3.4225)">
            <path
              d="M11.059307,0 C12.0959667,0 12.9363454,0.873178531 12.9363454,1.95029884 L12.8978156,7.45237265 L12.9363454,7.45237265 C12.8683946,8.01696744 11.3679675,5.9984957 8.16036986,9.58357342 C7.5792052,10.2331314 7.52234983,12.6534229 8.16036986,14.0862437 C8.61433273,15.1057218 10.1153187,15.6023907 9.9510349,15.6023907 L1.87703835,15.6023907 C0.840378694,15.6023907 0,14.7292122 0,13.6520919 L0,6.15874231 C0,6.05980334 2.77476928,7.52471563 3.9748662,6.79679144 C8.63019488,3.97308087 6.42753489,0 6.46817269,0 L11.059307,0 Z M10.9116159,0.890040107 L6.82128022,0.890040107 C6.65892757,2.64577047 6.24034806,4.75929862 4.96528519,5.66392935 C3.44023948,6.74591774 1.03275206,6.468272 1.03275206,6.80675655 L1.03275206,13.5147414 C1.03275206,14.1362267 1.50671962,14.6400401 2.09138823,14.6400401 L8.61191899,14.6400401 C9.14703608,14.6400401 7.38909403,12.4468503 8.12697883,9.65584822 C9.17494616,8.50508266 10.0409721,7.72012051 10.7250567,7.30096178 C10.8950328,7.19681241 11.310098,7.19681241 11.9702521,7.30096178 L11.9702521,2.01533879 C11.9702521,1.4382453 11.561576,0.962613814 11.0350752,0.897610814 L10.9116159,0.890040107 Z"
              fill={props.fill}
              fillRule="nonzero"
            ></path>
            <g
              stroke={props.fill}
              strokeLinecap="round"
              strokeWidth="0.9375"
              transform="translate(2.7921, 4.7703)"
            >
              <g transform="translate(3.0912, 0)">
                <line x1="0" x2="4.05759187" y1="0.3125" y2="0.3125"></line>
              </g>
              <g transform="translate(0, 3.125)">
                <line
                  x1="2.07677216"
                  x2="6.38927216"
                  y1="0.3125"
                  y2="0.3125"
                ></line>
                <line
                  x1="0.128125"
                  x2="0.496875"
                  y1="0.313464196"
                  y2="0.313464196"
                ></line>
              </g>
              <g transform="translate(0, 6.0445)">
                <line
                  x1="2.07677216"
                  x2="4.91708629"
                  y1="0.518048128"
                  y2="0.518048128"
                ></line>
                <line
                  x1="0.128125"
                  x2="0.496875"
                  y1="0.519012324"
                  y2="0.519012324"
                ></line>
              </g>
            </g>
            <ellipse
              cx="12.0874747"
              cy="11.701793"
              rx="4.22652735"
              ry="4.40699709"
              stroke={props.fill}
              strokeWidth="0.9375"
            ></ellipse>
            <path
              d="M11.5503084,12.5337481 L11.5503084,12.0948981 L11.5503084,9.65139382 C11.5503084,9.43739764 11.7237865,9.26391947 11.9377827,9.26391947 C12.1517789,9.26391947 12.3252571,9.43739764 12.3252571,9.65139382 L12.3252571,12.436768 C12.3252571,12.5728775 12.2149185,12.683216 12.078809,12.683216 C12.0666959,12.683216 12.0545993,12.682323 12.0426175,12.6805441 L11.8636761,12.6539781 C11.7946379,12.6437285 11.724938,12.6385828 11.6551431,12.6385828 C11.5972445,12.6385828 11.5503084,12.5916467 11.5503084,12.5337481 Z"
              fill={props.fill}
              fillRule="nonzero"
            ></path>
            <path
              d="M12.6555097,11.251889 C12.7187426,11.2407394 12.7838566,11.2537562 12.8379431,11.2883591 L13.0732818,11.4389215 C13.2700182,11.5647874 13.3817163,11.7885465 13.3640647,12.0214325 L13.254608,13.4655557 C13.2365552,13.7037363 13.0341426,13.8854611 12.7954009,13.8778294 C12.5690089,13.8705924 12.3913486,13.6811987 12.3985856,13.4548067 C12.3987631,13.449254 12.3990534,13.4437054 12.3994563,13.4381644 L12.5499401,11.3688089 C12.554198,11.3102565 12.5976946,11.2620834 12.6555097,11.251889 Z"
              fill={props.fill}
              transform="translate(12.8806, 12.563) scale(-1, -1) rotate(100) translate(-12.8806, -12.563)"
            ></path>
          </g>
          <g fillRule="nonzero" transform="translate(0.625, 0.625)">
            <path
              d="M4.6966623,0 C2.10298312,0 0,2.14796672 0,4.79712567 C0,7.44628462 2.10298312,9.59425134 4.6966623,9.59425134 C7.29034149,9.59425134 9.39332461,7.44628462 9.39332461,4.79712567 C9.39332461,2.14796672 7.29034149,0 4.6966623,0 Z"
              stroke="#FB8E3B"
              strokeWidth="1.25"
            ></path>
            <path
              d="M2.90625,6.51128936 L2.90625,3.22801546 C2.90625,2.99022618 3.09901629,2.79745989 3.33680556,2.79745989 L3.67048179,2.79745989 C3.90827106,2.79745989 4.10103735,2.99022618 4.10103735,3.22801546 L4.10103735,6.51128936 C4.10103735,6.74907863 3.90827106,6.94184492 3.67048179,6.94184492 L3.33680556,6.94184492 C3.09901629,6.94184492 2.90625,6.74907863 2.90625,6.51128936 Z M5.1246875,6.51128936 L5.1246875,3.22801546 C5.1246875,2.99022618 5.31745379,2.79745989 5.55524306,2.79745989 L5.88891929,2.79745989 C6.12670856,2.79745989 6.31947485,2.99022618 6.31947485,3.22801546 L6.31947485,6.51128936 C6.31947485,6.74907863 6.12670856,6.94184492 5.88891929,6.94184492 L5.55524306,6.94184492 C5.31745379,6.94184492 5.1246875,6.74907863 5.1246875,6.51128936 Z"
              fill="#FB8E3B"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
